<div class="no-content" [ngStyle]="{'background-color': isWhiteBackground ? 'white' : ''}">{{ text }}</div>
